// extracted by mini-css-extract-plugin
export default {"container":"Wi-z","links":"Xi-z"};